import { render, staticRenderFns } from "./myDeliver.vue?vue&type=template&id=cb6f850c&scoped=true&"
import script from "./myDeliver.vue?vue&type=script&lang=js&"
export * from "./myDeliver.vue?vue&type=script&lang=js&"
import style0 from "./myDeliver.vue?vue&type=style&index=0&id=cb6f850c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6f850c",
  null
  
)

export default component.exports